
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputUp as ObiInputUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-up.js';
 
 
 

 
 export const ObiInputUp = createComponent({
   react: React,
   tagName: 'obi-input-up',
   elementClass: ObiInputUpElement,
   events: {
     
   }
  });
 
 